"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SourceMediaBody = _interopRequireDefault(require("./SourceMediaBody"));
var _DisconnectedBody = _interopRequireDefault(require("./DisconnectedBody"));
var SourceListScreenPresenterItemBody = function SourceListScreenPresenterItemBody(_ref) {
  var value = _ref.value,
    type = _ref.type,
    live = _ref.live,
    hidden = _ref.hidden,
    disconnected = _ref.disconnected,
    onThumbnailReady = _ref.onThumbnailReady,
    isInitializing = _ref.isInitializing,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    AttendeeTileComponent = _ref.AttendeeTileComponent,
    isDirectorSource = _ref.isDirectorSource;
  if (disconnected) return /*#__PURE__*/_react["default"].createElement(_DisconnectedBody["default"], null);
  return /*#__PURE__*/_react["default"].createElement(_SourceMediaBody["default"], {
    value: value,
    type: type,
    live: live,
    hidden: hidden,
    onThumbnailReady: onThumbnailReady,
    isInitializing: isInitializing,
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession,
    AttendeeTileComponent: AttendeeTileComponent,
    isDirectorSource: isDirectorSource
  });
};
SourceListScreenPresenterItemBody.propTypes = {
  value: _propTypes["default"].string,
  type: _propTypes["default"].string,
  live: _propTypes["default"].bool,
  hidden: _propTypes["default"].bool,
  disconnected: _propTypes["default"].bool,
  onThumbnailReady: _propTypes["default"].func,
  isInitializing: _propTypes["default"].bool,
  attendeeTiles: _propTypes["default"].object,
  meetingSession: _propTypes["default"].object,
  AttendeeTileComponent: _propTypes["default"].elementType,
  isDirectorSource: _propTypes["default"].bool
};
var _default = exports["default"] = SourceListScreenPresenterItemBody;